import React, { useEffect, useState } from "react";
import { Button } from "@vds/buttons";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/system";
import "../../styles/deviceStyle.css";

import LocationTable from "../../global/components/Tables/LocationTable";

import { useSelector, useDispatch } from "react-redux";
import LocationPopupProvider from "./CreateLocation/LocationPopupProvider";
import { updateModal } from "../../store/actions/location";
import "./location.css";

const LocationDetails = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const stateObj = useLocation();
  const { search } = stateObj.state || {
    search: "",
  };

  const user = useSelector((state) => state.auth.user);
  const locationList = useSelector((state) => state.location.data.locations);
  const organizationList = useSelector(
    (state) => state.location.data.organizations
  );
  const alarmCounts = useSelector((state) => state.location.alarmCounts);
  const isLoadingAlarmCount = useSelector(
    (state) => state.location.isLoadingAlarmCount
  );
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState();
  const [selectedCloneOrganization, setSelectedCloneOrganization] =
    useState(false);
  const [orgPopupVisible, setOrgPopupVisible] = useState(
    state?.createlocation ?? false
  );

  const createLocation = () => {
    setSelectedCloneOrganization(false);
    setSelectedOrganization(null);
    dispatch(updateModal({ current_modal: "" }));
    //dispatch(updateModal({ current_modal: "ShipmentLocation" }));
    dispatch(updateModal({ current_modal: 'locationOptPopup' }));
  };

  return (
    <div style={{ minHeight: "65vh", margin: "0 auto" }}>
      <Box sx={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h2 className="page-common-heading_tittle">Locations</h2>
          <div style={{ alignContent: "end" }}>
            {user?.role?.permissions?.Locations?.create ? (
              <Button
                style={{
                  backgroundColor: "black",
                  color: "white",
                  fontSize: "16px",
                  lineHeight: "20px",
                  letterSpacing: "0.5px",
                  fontWeight: 700,
                }}
                size="large"
                shape="round"
                use="primary"
                onClick={createLocation}
              >
                Add location
              </Button>
            ) : null}
          </div>
        </div>
      </Box>
      <LocationTable
        key={search}
        locationList={locationList}
        organizationList={organizationList}
        alarmCounts={alarmCounts}
        isLoadingAlarmCount={isLoadingAlarmCount}
        searchLoc={search}
        permissions={user?.role?.permissions}
        pagination={{
          position: ["bottomRight"],
        }}
        selectedOrganization={selectedOrganization}
        setSelectedOrganization={setSelectedOrganization}
        setSelectedCloneOrganization={setSelectedCloneOrganization}
        selectedCloneOrganization={selectedCloneOrganization}
        tableLoading={tableLoading}
        tableTitle="Active rules"
      />
      <LocationPopupProvider />
    </div>
  );
};

export default LocationDetails;
